import { createRoute } from './utils'

const privateRoutes = {
	account: createRoute('/me', {
		id: 'account',
		protect: true,
		localize: true,
	}),

	settings: {
		profile: createRoute('/settings/profile', {
			id: 'settings-profile',
			protect: true,
			localize: true,
		}),
		password: createRoute('/settings/password', {
			id: 'settings-password',
			protect: true,
			localize: true,
		}),
		changeEmail: createRoute('/settings/change-email', {
			id: 'settings-change-email',
			protect: true,
			localize: true,
		}),
		twoFactor: createRoute('/settings/two-factor', {
			id: 'settings-two-factor',
			protect: true,
			localize: true,
		}),
	},
}

export default privateRoutes
